
// import React from "react";

// const FAQSection = () => {
//   const faqs = [
//     { q: "Can we conduct elections digitally?", a: "Yes. Set positions, voting window, verify voters, and export results with audit logs." },
//     { q: "How do entry passes work?",          a: "Residents generate a QR-based pass for visitors; guards verify at the gate using the app." },
//     { q: "Is there a complaints workflow?",    a: "Residents raise tickets which staff resolve with statuses, SLAs, comments, and attachments." },
//     { q: "Do you support payments?",           a: "Yes. Maintenance dues can be invoiced and collected with payment gateways." },
//   ];

//   return (
//     <section id="faq" className="py-5 bg-light">
//       <div className="container">
//         <div className="text-center mb-4">
//           {/* <h2 className="fw-bold text-primary-label">Frequently Asked Questions</h2> */}
//                     <h2 className="fw-bold text-secondary">Frequently Asked Questions</h2>

//         </div>

//         <div className="accordion" id="faqAccordion">
//           {faqs.map((item, i) => (
//             <div className="accordion-item" key={i}>
//               <h2 className="accordion-header" id={`faqHeading${i}`}>
//                 <button
//                   className={`accordion-button ${i !== 0 ? "collapsed" : ""}`}
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target={`#faqCollapse${i}`}
//                   aria-expanded={i === 0 ? "true" : "false"}
//                   aria-controls={`faqCollapse${i}`}
//                 >
//                   {item.q}
//                 </button>
//               </h2>
//               <div
//                 id={`faqCollapse${i}`}
//                 className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
//                 aria-labelledby={`faqHeading${i}`}
//                 data-bs-parent="#faqAccordion"
//               >
//                 <div className="accordion-body">{item.a}</div>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default FAQSection;

import React, { useState } from "react";
import "./flip-cards.mobile.css"; // shared flip foundation
import "./faq.mobile.css";        // optional small tweaks for FAQ

const FAQSection = () => {
  const faqs = [
    { q: "Can we conduct elections digitally?", a: "Yes. Set positions, voting window, verify voters, and export results with audit logs." },
    { q: "How do entry passes work?",          a: "Residents generate a QR-based pass for visitors; guards verify at the gate using the app." },
    { q: "Is there a complaints workflow?",    a: "Residents raise tickets which staff resolve with statuses, SLAs, comments, and attachments." },
    { q: "Do you support payments?",           a: "Yes. Maintenance dues can be invoiced and collected with payment gateways." },
  ];

  // Mobile flip state—array of booleans per card
  const [flipped, setFlipped] = useState(() => faqs.map(() => false));
  const toggleFlip = (i) =>
    setFlipped((prev) => prev.map((f, idx) => (idx === i ? !f : f)));

  return (
    <section id="faq" className="py-5 bg-light">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-secondary ">Frequently Asked Questions</h2>
        </div>

        {/* --- MOBILE (< md): 2×N flip-card grid --- */}
        <div className="d-md-none">
          <div className="grid-2-mobile" role="list" aria-label="Frequently asked questions">
            {faqs.map((item, i) => {
              const hintId = `faq-${i}-hint`;
              const liveId = `faq-${i}-live`;

              return (
                <div key={i} role="listitem">
                  {/* SR-only guidance & live status */}
                  <span id={hintId} className="visually-hidden">
                    Press Enter or Space to flip and reveal the answer.
                  </span>
                  <span id={liveId} className="visually-hidden" aria-live="polite">
                    {flipped[i] ? "Answer shown." : "Answer hidden."}
                  </span>

                  <button
                    type="button"
                    className={`flip-card faq-flip ${flipped[i] ? "is-flipped" : ""}`}
                    onClick={() => toggleFlip(i)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        toggleFlip(i);
                      }
                    }}
                    aria-expanded={flipped[i]}
                    aria-describedby={`${hintId} ${liveId}`}
                    aria-roledescription="flip card"
                    aria-label={`FAQ: ${item.q}`}
                  >
                    <div className="flip-card-inner">
                      {/* FRONT: Question */}
                      <div className="flip-card-face flip-card-front" aria-hidden={flipped[i]}>
                        <div className="d-flex align-items-center mb-2">
                          <div className="icon-wrap icon-animated text-primary-label" aria-hidden="true">
                            <i className="bi bi-question-circle icon-lg"></i>
                          </div>
                          <h6 className="mb-0 ms-2">{item.q}</h6>
                        </div>
                        <p className="text-muted mb-0">Tap to view the answer</p>
                      </div>

                      {/* BACK: Answer */}
                      <div className="flip-card-face flip-card-back" aria-hidden={!flipped[i]}>
                        <h6 className="mb-2">Answer</h6>
                        <p className="mb-2">{item.a}</p>
                        <span className="hint">Tap to flip back</span>
                      </div>
                    </div>
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* --- DESKTOP/TABLET (≥ md): Bootstrap accordion (your original) --- */}
        <div className="d-none d-md-block">
          <div className="accordion" id="faqAccordion">
            {faqs.map((item, i) => (
              <div className="accordion-item" key={i}>
                <h2 className="accordion-header" id={`faqHeading${i}`}>
                  <button
                    className={`accordion-button ${i !== 0 ? "collapsed" : ""}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#faqCollapse${i}`}
                    aria-expanded={i === 0 ? "true" : "false"}
                    aria-controls={`faqCollapse${i}`}
                  >
                    {item.q}
                  </button>
                </h2>
                <div
                  id={`faqCollapse${i}`}
                  className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                  aria-labelledby={`faqHeading${i}`}
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">{item.a}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default FAQSection;
